import { render, staticRenderFns } from "./BowLogo.vue?vue&type=template&id=293266fa&"
import script from "./BowLogo.vue?vue&type=script&lang=js&"
export * from "./BowLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports